import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.articleUnitsOfMeasure.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.articleUnitsOfMeasure.actionsLoading;
export const getItems = (state:RootState) => state.articleUnitsOfMeasure.items;
export const getItemsSelect = (state:RootState) => state.articleUnitsOfMeasure.dropDownItems;
export const getItemsCount = (state:RootState) => state.articleUnitsOfMeasure.itemsCount;
export const getItemForEdit = (state:RootState) => state.articleUnitsOfMeasure.itemForEdit;
export const getError = (state:RootState) => state.articleUnitsOfMeasure.error;
export const getErrorAction = (state:RootState) => state.articleUnitsOfMeasure.errorAction;
export const validationErrors = (state: RootState) => state.articleUnitsOfMeasure.validationErrors;
